module.exports = __webpack_public_path__ + "static/media/selfie.7b2329fa.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/selfie.webp
// module id = 106
// module chunks = 0